var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPushTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.071,
    y: 110.568,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 158.5289 -130.8663)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.306,
    y: 298.333,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -137.3733 570.4594)",
    width: 16.307,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.965,
    y: 185.674,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 189.6276 -55.7568)",
    width: 16.307,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.18,
    y: 447.205,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 11.4785 929.8605)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.624,
    y: 73.015,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 142.9735 -168.422)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.858,
    y: 260.779,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -46.7261 532.8992)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.412,
    y: 223.226,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 43.9359 495.3487)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.177,
    y: 35.462,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 127.4196 -205.9778)",
    width: 16.306,
    height: 30.697
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.42,145.305l-90.954,90.953c-3.184,3.185-3.184,8.347,0,11.531c1.591,1.591,3.679,2.387,5.765,2.387 s4.173-0.796,5.765-2.387l90.954-90.953c3.184-3.185,3.184-8.347,0-11.531C324.767,142.122,319.604,142.122,316.42,145.305z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.518,
    y: 148.121,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 174.0846 -93.3108)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.944,
    y: 259.441,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 464.7806 742.11)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.496,
    y: 221.888,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 555.4633 704.5527)",
    width: 16.307,
    height: 30.696
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.049,
    y: 184.335,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 646.1022 667.0084)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.985,327.144c0.654-4.132-0.769-8.315-3.806-11.191L223.2,303.669l-2.309-17.718 c-0.54-4.147-3.087-7.758-6.814-9.658c-3.728-1.9-8.147-1.84-11.82,0.161L186.563,285l-17.564-3.279 c-4.114-0.773-8.334,0.538-11.29,3.496c-2.959,2.958-4.266,7.178-3.498,11.293l3.28,17.565l-8.548,15.693 c-2,3.674-2.06,8.092-0.162,11.819c1.899,3.728,5.509,6.275,9.656,6.816l17.719,2.309l12.284,12.979 c2.414,2.55,5.751,3.962,9.203,3.962c0.66,0,1.324-0.052,1.987-0.157c4.131-0.655,7.669-3.301,9.464-7.079l7.673-16.14 l16.138-7.67C236.683,334.815,239.329,331.276,239.985,327.144z M217.317,343.123l0.003-0.009l0.001-0.001 C217.32,343.117,217.319,343.12,217.317,343.123z M208.601,330.107c-2.625,1.248-4.758,3.382-6.006,6.007l-5.953,12.521 l-9.535-10.075c-1.997-2.108-4.683-3.474-7.564-3.852l-13.747-1.79l6.631-12.174c1.389-2.552,1.862-5.53,1.33-8.392 l-2.545-13.628l13.628,2.544c2.858,0.535,5.839,0.063,8.39-1.328l12.176-6.632l1.792,13.747c0.375,2.882,1.745,5.57,3.857,7.57 l10.07,9.53L208.601,330.107z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.391,
    y: 296.993,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 374.1215 779.6583)",
    width: 16.306,
    height: 30.696
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.464,169.622l-25.73-25.731c-8.21-8.21-21.158-9.602-30.786-3.312c-21.459,14.014-50.211,11.006-68.365-7.149 c-18.155-18.154-21.161-46.905-7.149-68.365c6.29-9.629,4.896-22.578-3.312-30.786L342.385,8.542 c-11.382-11.38-29.9-11.382-41.282,0L8.55,301.096C3.036,306.609,0,313.939,0,321.736c0,7.798,3.036,15.128,8.55,20.641 l25.736,25.737c8.21,8.209,21.158,9.602,30.786,3.312c21.459-14.014,50.209-11.005,68.365,7.148 c18.154,18.155,21.16,46.907,7.148,68.366c-6.289,9.63-4.895,22.579,3.313,30.786l25.73,25.731 c5.691,5.69,13.166,8.536,20.641,8.536c7.475,0,14.95-2.845,20.64-8.536l292.555-292.555 C514.845,199.523,514.845,181.003,503.464,169.622z M491.935,199.373L199.381,491.927c-5.024,5.025-13.198,5.023-18.222,0 l-25.731-25.731c-2.784-2.783-3.284-7.132-1.19-10.34c18.206-27.881,14.308-65.231-9.271-88.811 c-13.641-13.64-31.884-20.693-50.243-20.693c-13.377,0-26.816,3.748-38.568,11.423c-3.207,2.094-7.555,1.595-10.34-1.191 l-25.736-25.737c-2.434-2.433-3.774-5.669-3.774-9.111c0-3.441,1.34-6.677,3.774-9.11L312.633,20.073 c5.024-5.026,13.199-5.024,18.222,0l25.737,25.737c2.784,2.784,3.285,7.133,1.19,10.34 c-18.208,27.881-14.308,65.232,9.271,88.811c23.579,23.577,60.93,27.475,88.811,9.27c3.207-2.093,7.555-1.595,10.34,1.191 l25.73,25.73C496.957,186.176,496.957,194.35,491.935,199.373z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.732,
    y: 409.651,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 102.1612 892.3159)",
    width: 16.307,
    height: 30.697
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.285,
    y: 372.098,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 192.8224 854.7628)",
    width: 16.307,
    height: 30.696
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.619,221.609l-53.401,53.399c-3.184,3.185-3.184,8.347,0,11.532c1.591,1.591,3.679,2.387,5.765,2.387 s4.173-0.796,5.765-2.387l53.401-53.4c3.184-3.185,3.184-8.347,0-11.531C325.966,218.428,320.803,218.425,317.619,221.609z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.838,
    y: 334.545,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 283.4605 817.2079)",
    width: 16.306,
    height: 30.696
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushTicket);
export default __webpack_public_path__ + "static/media/push_ticket.53f52c1ffa9df485288b9a6a924b3613.svg";
export { ForwardRef as ReactComponent };